import React from "react";
import { FaCameraRetro } from "react-icons/fa";
import { GiNotebook } from "react-icons/gi";
import { SlNote } from "react-icons/sl";

const skillsData = [
  {
    name: "Luxury Limousine Selection",
    icon: (
      <img
      src="https://thumbs.dreamstime.com/b/elegant-white-limousine-navigating-bustling-cityscape-dusk-experience-epitome-opulence-sophistication-291894066.jpg"
      alt=""
      className="rounded-full w-20 h-20"
    />
      // <FaCameraRetro className="text-5xl text-primary group-hover:text-black duration-300" />
    ),
    link: "#",
    description: "Our top-of-the-line vehicles will arrive spotless and fully stocked.",
    aosDelay: "0",
  },
  {
    name: "24/7 Order Available",
    icon: (
      <img
      src="https://carcoachreports.com/wp-content/uploads/2013/12/red-carpet-celebrity-cars.jpg"
      alt=""
      className="rounded-full w-20 h-20"
    />
      // <GiNotebook className="text-5xl text-primary group-hover:text-black duration-300" />
    ),
    link: "#",
    description: "We are available for bookings at any time and provide a private, discreet experience.",
    aosDelay: "500",
  },
  {
    name: "Instant Online Booking",
    icon: (
      <img
      src="https://images.ctfassets.net/2d5q1td6cyxq/1M4P3G73Fh6GUrwiNqWJBp/d8b3aeb0c12b8c29e759ee1d7e3d09b9/PD05460_-_mobile_USEN_nav_spotlight_services_phone.png"
      alt=""
      className="rounded-full w-20 h-20"
    />
      // <SlNote className="text-5xl text-primary group-hover:text-black duration-500" />
    ),
    link: "#",
    description: "Book your rides conveniently online using our state-of-the-art booking tool.",
    aosDelay: "1000",
  },
];
const Services = () => {
  return (
    <>
      <span id="about"></span>
      <div className="dark:bg-black dark:text-white py-14 sm:min-h-[600px] sm:grid sm:place-items-center">
        <div className="container">
          <div className="pb-12">
            <h1
              data-aos="fade-up"
              className="text-3xl font-bold text-center sm:text-4xl font-Ubuntu"
            >
              Why Choose Us
            </h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {skillsData.map((skill) => (
              <div
                key={skill.name}
                data-aos="fade-up"
                data-aos-delay={skill.aosDelay}
                className="card text-center group space-y-3 sm:space-y-6 p-4 sm:py-16 bg-[#555]  hover:bg-primary duration-300 text-white rounded-lg"
              >
                <div className="grid place-items-center">{skill.icon}</div>
                <h1 className="text-2xl font-bold">{skill.name}</h1>
                <p>{skill.description}</p>
                <a
                  href={"https://customer.moovs.app/marina-global-transportation"}
                  className="inline-block text-lg font-semibold py-3 text-primary group-hover:text-white duration-300"
                >
                  Learn more
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
